import * as ActionType from 'actions/ActionTypeConstants';

export const signOutActions = {
  start: () => ({
    type: ActionType.SIGN_OUT as typeof ActionType.SIGN_OUT,
  }),
};

export type signOutAction = ReturnType<typeof signOutActions.start>;
